// Médaillon d'un collègue dans les pickers d'affectation (transfert rapide, modale
// « Plus d'options », création de tâche, réassignation en masse).
//
// Retour PO 2026-08-09 : on voyait une icône générique identique pour tout le monde
// alors que la photo de profil existe. Quand `avatar_url` est renseigné on montre la
// photo ; sinon on retombe sur les initiales (jamais une silhouette anonyme, qui ne
// distingue pas deux collègues l'un de l'autre).

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import type { Colleague } from '@/hooks/useAbsences'
import { initialsFromLabel } from '@/lib/searchCategories'
import { cn } from '@/lib/utils'

import { colleagueLabel } from './absenceHelpers'

interface ColleagueAvatarProps {
    colleague: Colleague
    className?: string
}

export function ColleagueAvatar({ colleague, className }: ColleagueAvatarProps) {
    // `alt=""` : le nom du collègue est TOUJOURS affiché juste à côté → médaillon décoratif.
    return (
        <Avatar className={cn('h-6 w-6 shrink-0', className)}>
            {colleague.avatar_url && <AvatarImage src={colleague.avatar_url} alt="" />}
            <AvatarFallback className="bg-primary/10 text-[10px] font-medium text-primary">
                {initialsFromLabel(colleagueLabel(colleague))}
            </AvatarFallback>
        </Avatar>
    )
}
